import { useSelector } from "react-redux";
import ReusableDatagrid from "../components/ReusableDatagrid";

const columnsConfig = [
  {
    field: "action",
    headerName: "Actions for Paralegal",
    width: 460,
    type: "select",
    label: "Select Action",
    options: [
      { value: "Maintain List of References in Max-IDS", label: "Maintain List of References in Max-IDS" },
      { value: "Prepare Draft SB08’s for Co-Counsel", label: "Prepare Draft SB08’s for Co-Counsel" },
      { value: "Prepare Issue Fee Checklist(s) with a Full Reference Check", label: "Prepare Issue Fee Checklist(s) with a Full Reference Check" },
      { value: "Prepare Issue Fee Checklist(s) without a Full Reference Check", label: "Prepare Issue Fee Checklist(s) without a Full Reference Check" },
      { value: "Calculate PTA and Expiration Dates", label: "Calculate PTA and Expiration Dates" },
      {value: "Other", label: "Other"}
    ],
  },
  {
    field: "wsgrResponsible",
    headerName: "WSGR Responsible?",
    width: 180,
    label: "Select Yes/No",
    type: "select",
    options: [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ],
  },
  {
    field: "matters",
    headerName: "Family No(s)",
    width: 260,
    placeholder: "Enter Family No(s)",
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 260,
    placeholder: "Enter Notes",
  },
];

export default function ParalegalInstructions({ mode }) {
  const savedData = useSelector((state) => state.kotClient.paralegalInstructions);
  return <ReusableDatagrid title="Instructions for Paralegal" columnsConfig={columnsConfig} initialRows={savedData} section={"paralegalInstructions"} mode={mode} />;
}
